module.exports = __webpack_public_path__ + "img/cloudy_icon.e21d71b4.svg";